<template>
  <div class="flex justify-center items-center h-screen">
    <div class="w-4/5 flex flex-col items-center">
      <p class="text-2xl">Carregando...</p>
      <vs-progress indeterminate color="primary">primary</vs-progress>
    </div>
  </div>
</template>

<script>
import ability from '../../services/ability';
import service from '../../services';

import serviceStatusNotification from './../../services/statusNotification';
import { updateStoreDataEmpresa } from './../../services/multiple-empresa';
import { clearCacheStorage } from '../../services/cacheService';

export default {
  methods: {
    loginEmpresa() {
      const { selectedEmpresa } = this.$store.state;
      const newEmpresa = selectedEmpresa.id_empresa;
      const objSend = {
        idUsuario: this.$store.state.idUsuarioInitialLogin,
        idEmpresa: newEmpresa,
      };

      service
        .post('Login', 'muda-empresa-usuario', objSend)
        .then((res) => {
          const { token, logoNovaEmpresa, permission } = res.data;

          clearCacheStorage();
          localStorage.setItem('idEmpresa', newEmpresa.toString());
          localStorage.setItem('user-token', token);
          localStorage.setItem('logo', logoNovaEmpresa);

          if (this.$ability && permission) {
            ability.saveLocalPermission(permission);
            this.$ability.update(permission);
          }

          updateStoreDataEmpresa();

          const { oldValue } = serviceStatusNotification;
          serviceStatusNotification.updateCountBadge(oldValue);

          setTimeout(() => {
            this.$router.push('/dashboard');
          }, 500);
        })
        .catch((e) => {
          console.log('Erro: ', e);
        });
    },
  },
  mounted() {
    this.loginEmpresa();
  },
};
</script>
